export default __webpack_public_path__ + "static/left-93623c80ec7f8d64fc52339a9cc8e87c.png";